import * as React from 'react';
import { Query } from 'react-apollo';
import ToastActions from 'actions/ToastActions';
import { WithRouterProps, withRouter } from 'react-router';
import GET_ENGAGEMENT_REPORT_DOWNLOAD_URL from 'admin/engagementReports/queries/GetEngagementReportDownloadUrl.gql';
import {
  GetEngagementReportDownloadUrl,
  GetEngagementReportDownloadUrlVariables,
} from 'admin/engagementReports/queries/__generated__/GetEngagementReportDownloadUrl';

type Props = WithRouterProps;

export function AdminEngagementReportDownloadContainer(props: Props) {
  const redirectHomeOnFail = () => props.router.push('/');

  const { org_uuid: orgUuid, week } = props.location.query;

  if (!orgUuid || !week) {
    redirectHomeOnFail();
    return null;
  }

  return (
    <Query<GetEngagementReportDownloadUrl, GetEngagementReportDownloadUrlVariables>
      query={GET_ENGAGEMENT_REPORT_DOWNLOAD_URL}
      variables={{ orgUuid, week }}>
      {({ loading, error, data }) => {
        if (error || loading) {
          return null;
        }

        if (data?.engagementReports?.reportDownloadUrl?.found) {
          window.location.assign(data.engagementReports.reportDownloadUrl.downloadUrl);
        } else {
          ToastActions.showErrorToast('Engagement report does not exist or has expired.');

          redirectHomeOnFail();
        }

        return null;
      }}
    </Query>
  );
}

export default withRouter(AdminEngagementReportDownloadContainer);
